/* eslint-disable react/prop-types */
import React from 'react';

const Item = props => (
  <div
    className = 'item'
    title = {props.video_title}
    onClick = {
      () => {
        window.open(props.video_url);
      }
    }
  >
    <img src = {props.video_cover} alt = {props.video_title}/>
    <p>{props.video_title}</p>
    <div className = 'play-icon'></div>
  </div>
)

export default Item;
